import styleFn, {compose} from '../util'

const position = styleFn({propName: 'position'})

const getStyle = propName => styleFn({propName})
const directions = ['top', 'left', 'right', 'bottom'].map(getStyle)

export default compose(position, ...directions)
